import React, { useState } from "react";

const ParentSiteUpdate = ({ currentItem, onCancel, onSubmit }) => {
    const [item, setItem] = useState({ ...currentItem, tel: currentItem.tel_number });

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                const { name, email, tel } = item;
                onSubmit({ newName: name, newEmail: email, newTel: tel });
            }}
        >
            <div className="form-body">
                <div className="form-group">
                    <label className="control-label">
                        Name
                        <span className="required"> * </span>
                    </label>
                    <input
                        type="text"
                        name="name"
                        onChange={({ currentTarget: { value } }) => setItem({ ...item, name: value })}
                        defaultValue={item.name}
                        data-required="1"
                        placeholder="enter parent site name"
                        className="form-control input-height"
                    />
                </div>

                <div className="form-group">
                    <label className="control-label">
                        Email
                        <span className="required"> * </span>
                    </label>
                    <input
                        type="email"
                        defaultValue={item.email}
                        onChange={({ currentTarget: { value } }) => setItem({ ...item, email: value })}
                        className="form-control input-height"
                        name="email"
                        placeholder="Email Address"
                    />
                </div>

                <div className="form-group">
                    <label className="control-label">
                        Mobile No.
                        <span className="required"> * </span>
                    </label>

                    <input
                        name="tel_number"
                        defaultValue={item.tel}
                        onChange={({ currentTarget: { value } }) => setItem({ ...item, tel: value })}
                        type="text"
                        placeholder="mobile number"
                        className="form-control input-height"
                    />
                </div>
                <div className="text-center">
                    <button type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle margin-right-10 btn-default" onClick={onCancel}>
                        <i className="material-icons text-danger">cancel</i> Cancel
                    </button>
                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success">
                        Update <i className="material-icons">arrow_forward</i>
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ParentSiteUpdate;
